import { createContext } from 'react';
import { noop } from 'lodash';
import { useDrawer } from '../../hooks/useDrawer';

export interface DrawerContextType {
    setDrawerChildren: ReturnType<typeof useDrawer>['setChildren'];
    setDrawerSize: ReturnType<typeof useDrawer>['setSize'];
    setDrawerCallbacks: ReturnType<typeof useDrawer>['setDrawerCallbacks'];
    openDrawer: ReturnType<typeof useDrawer>['openDrawer'];
    closeDrawer: ReturnType<typeof useDrawer>['closeDrawer'];
}
export const DrawerContext = createContext<DrawerContextType>({
    setDrawerChildren: noop,
    setDrawerSize: noop,
    setDrawerCallbacks: noop,
    openDrawer: noop,
    closeDrawer: noop,
});
